import React, { useEffect, useRef, useState } from 'react';
import backIcon from '../../../imgs/backIcon.svg';
import HomeSidebar from '../homeSidebar/homeSidebar';
import BountyOfferCard from './BountyOfferCard';
import { useHistory } from 'react-router-dom';
import { gql, useLazyQuery } from '@apollo/client';
import { GET_OFFERS, OFFER_COUNT } from '../../../graphql/query/offers';
import { Spin } from 'antd';
import { withSocket } from '../../../utils/withSocket';
import { removeDuplicates } from '../../../utils/helpers/reusableFuntions';

const BountyCardInfo = ({ socket }) => {
  const history = useHistory();

  const {
    location: {
      state: { myBounty },
    },
  } = history;

  const { fullName, company, demandPrice, title, reason, id, bountyType } = myBounty;

  const [start, setStart] = useState(0);
  const [limit] = useState(5);
  const [myOffers, setMyOffers] = useState([]);
  const [rendering, setRendering] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [isNextRequest, setIsNextRequest] = useState(true);
  const loader = useRef(null);
  const [offerCount, setOfferCount] = useState(0);
  const [page, setPage] = useState(1);
  const [offerId, setOfferId] = useState('');

  const [getOfferCount] = useLazyQuery(gql(OFFER_COUNT), {
    fetchPolicy: 'cache-and-network',
    onCompleted: ({ offersConnection }) =>
      setOfferCount(offersConnection?.aggregate?.count),
  });

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) {
      observer.observe(loader.current);
    }
  }, []);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      setPage((page) => page + 1);
    }
  };

  useEffect(() => {
    if (isNextRequest) {
      setStart(start + 5);
      setIsNextRequest(false);
      getOffers({
        variables: {
          bountyId: id,
          start: start + 5,
          limit,
        },
      });
    }
  }, [page]);

  const [getOffers, { data: myOffersList }] =
    useLazyQuery(gql(GET_OFFERS), {
      fetchPolicy: 'cache-and-network',
    });

  useEffect(() => {
    if (!myOffers.length && rendering) {
      setRendering(false);
      getOffers({
        variables: { bountyId: id, start, limit },
      });
    }
  }, []);

  useEffect(() => {
    getOfferCount({
      variables: {
        bountyId: id,
      },
    });
  }, [id]);

  useEffect(() => {
    if (myOffersList && myOffersList.offers) {
      setIsNextRequest(true);
      if (myOffersList.offers.length) {
        if (myOffersList.offers.length < 5) setHasMore(false);
        let mergeOffers = [...myOffers, ...myOffersList.offers];
        const result = removeDuplicates(mergeOffers);
        setMyOffers(
          result.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at),
          ),
        );
      } else {
        setHasMore(false);
      }
    }
  }, [myOffersList]);

  useEffect(() => {
    socket.on(`offer-update-${id}`, () => {
      console.log(`offer-update-${id}`)
      setStart(0);
      getOffers({
        variables: {
          bountyId: id,
          start: 0,
          limit: 5,
        },
      });
      setHasMore(true);
      setIsNextRequest(false);
      // setStart(0);
    });
    return () => {
      socket.off(`offer-update-${id}`);
    };
  }, []);

  // console.log(offerId, 'offerId')

  return (
    <div className="home-container">
      <HomeSidebar></HomeSidebar>
      <div className="home-content bounty-card-details">
        <div className="feed-card-wrapper">
          <button className="back-icon" onClick={() => history.goBack()}>
            <img src={backIcon} alt="backIcon" />
            Back
          </button>
          <div>
            <div className="row m-0 justify-content-between">
              <h2 className="heading">{fullName || company}</h2>
              <h2 className="small-heading">${demandPrice}</h2>
            </div>
            <p>
              {title} at The {company}
            </p>
            <span>For {reason}</span>
          </div>
        </div>
        {myOffers.length ? null : (
          <div className="mt-4 ml-4">
            <span>You have no offers yet.</span>
          </div>
        )}

        <div className="bounty-card-feeds">
          {myOffers && myOffers.length ? (
            myOffers.map((offer, index) => {
              return (
                <>
                  {offer.status === 'accepted' ? (
                    <div className="active-offers">
                      <h2 className="small-heading">Purchased intro</h2>
                      <p className="mt-2" >
                        Mark as complete after the meeting has actually
                        happened.
                      </p>
                      <BountyOfferCard
                        key={index}
                        offer={offer}
                        bountyId={id}
                        fullName={fullName}
                        setOfferId={setOfferId}
                        demandPrice={demandPrice}
                        company={company}
                        bountyType={bountyType}
                      />
                    </div>
                  ) : offer.status === 'hold' ? (
                    <div className="on-hold-offers">
                      <h2 className="small-heading">
                        {offerCount} Offers on hold
                      </h2>
                      <p>
                        Offers on hold will be available when active offer has
                        completed.
                      </p>
                      <BountyOfferCard
                        key={index}
                        offer={offer}
                        bountyId={id}
                        fullName={fullName}
                        setOfferId={setOfferId}
                        demandPrice={demandPrice}
                        company={company}
                        bountyType={bountyType}
                      />
                    </div>
                  ) : (
                        <>
                          <BountyOfferCard
                            key={index}
                            offer={offer}
                            bountyId={id}
                            fullName={fullName}
                            setOfferId={setOfferId}
                            demandPrice={demandPrice}
                            company={company}
                            bountyType={bountyType}
                          />
                        </>
                      )}
                </>
              );
            })
          ) : (
              <></>
            )}
          {hasMore && (
            <div className="loading" ref={loader}>
              <Spin spinning={loader} className="spin-loading" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withSocket(BountyCardInfo);
